module.exports = __webpack_public_path__ + "media/images/athletes/1476-6f1b8500bcd1c223ae61b0b780f54033.png";